import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { MentionableUser } from '@ps/survey-utils';

import { MentionableUserDto } from '../dtos/mentionable-user.dto';
import { MentionableUserMapper } from './mappers/mentionable-user.mapper';

@Injectable({ providedIn: 'root' })
export class MentionableUsersApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);
  private readonly _mapper = new MentionableUserMapper();

  private readonly _baseUrl = `${this._env.pureSpectrum.url}/notification-center/mentionable-users`;

  public mentionableUsers(): Observable<MentionableUser[]> {
    return this._http
      .get<MentionableUserDto[]>(this._baseUrl)
      .pipe(map((dtos) => this._mapper.fromDtoList(dtos)));
  }
}
